/**
 * Geracao de identificadores.
 *
 * Usamos ULID e nao UUID v4 por duas razoes que importam para este projeto:
 *  - Sao ordenaveis por tempo, o que torna a paginacao e o sync incrementais
 *    simples sem um indice extra.
 *  - Sao gerados no cliente, logo funcionam offline sem coordenacao (ADR-0007).
 */

const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford base32, sem I L O U
const ENCODING_LEN = ENCODING.length;
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function randomBytes(n: number): Uint8Array {
  const bytes = new Uint8Array(n);
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}

function encodeTime(now: number): string {
  let out = '';
  let time = now;
  for (let i = TIME_LEN - 1; i >= 0; i--) {
    const mod = time % ENCODING_LEN;
    out = ENCODING[mod] + out;
    time = (time - mod) / ENCODING_LEN;
  }
  return out;
}

function encodeRandom(): string {
  const bytes = randomBytes(RANDOM_LEN);
  let out = '';
  for (let i = 0; i < RANDOM_LEN; i++) {
    out += ENCODING[bytes[i]! % ENCODING_LEN];
  }
  return out;
}

/** ULID de 26 caracteres, ordenavel por tempo de criacao. */
export function ulid(now: number = Date.now()): string {
  return encodeTime(now) + encodeRandom();
}

/** Extrai o instante de criacao de um ULID. Util em depuracao e auditoria. */
export function ulidTime(id: string): Date | null {
  if (id.length < TIME_LEN) return null;
  let time = 0;
  for (let i = 0; i < TIME_LEN; i++) {
    const idx = ENCODING.indexOf(id[i]!);
    if (idx === -1) return null;
    time = time * ENCODING_LEN + idx;
  }
  return new Date(time);
}

export function isUlid(value: string): boolean {
  if (value.length !== TIME_LEN + RANDOM_LEN) return false;
  for (const char of value) {
    if (!ENCODING.includes(char)) return false;
  }
  return true;
}

/**
 * Identificador estavel deste dispositivo. Necessario para o motor de sync
 * saber ignorar as alteracoes que ele proprio enviou.
 */
const DEVICE_ID_KEY = 'flos.deviceId';

export function deviceId(): string {
  const stored = globalThis.localStorage?.getItem(DEVICE_ID_KEY);
  if (stored) return stored;
  const fresh = ulid();
  globalThis.localStorage?.setItem(DEVICE_ID_KEY, fresh);
  return fresh;
}

/**
 * Codigo curto e legivel para convites de familia (Milestone 2).
 * Sem vogais, para nao formar palavras por acaso, e sem caracteres ambiguos.
 */
const INVITE_ALPHABET = '23456789BCDFGHJKMNPQRSTVWXZ';

export function inviteCode(length = 6): string {
  const bytes = randomBytes(length);
  let out = '';
  for (let i = 0; i < length; i++) {
    out += INVITE_ALPHABET[bytes[i]! % INVITE_ALPHABET.length];
  }
  return out;
}
